mtl.alloy.factory['repair-ticker'] = (function ($) {
    'use strict';

    /**
     * Initialises the element as a repair-ticker controller.
     */
    return function repairTicker(element, options) {

        var $element = $(element);
        var $bubbles = $element.children();

        var currentIndex = 0;
        var transitionDuration = 500;
        var pauseDuration = 5000;

        $bubbles.eq(currentIndex).addClass('active');

        function nextBubble() {

            var thisIndex = currentIndex;
            var nextIndex = (currentIndex + 1) % $bubbles.length;

            var $thisBubble = $bubbles.eq(thisIndex);
            var $nextBubble = $bubbles.eq(nextIndex);

            $thisBubble.stop(true, false)
                .delay(33)
                .queue(function (next) {
                    $(this).addClass('leave').removeClass('active enter');
                    next();
                })
                .delay(transitionDuration)
                .queue(function (next) {
                    $(this).removeClass('leave');
                    next();
                })
            ;

            $nextBubble.stop(true, false)
                .queue(function (next) {
                    $(this).removeClass('leave').addClass('active enter');
                    next();
                })
                .delay(33)
                .queue(function (next) {
                    $(this).removeClass('enter');
                    next();
                })
            ;

            setTimeout(nextBubble, pauseDuration + transitionDuration);
            currentIndex = nextIndex;

        }

        setTimeout(nextBubble, pauseDuration);

    };

}(jQuery));
